var $input = $("#user_documento");

$input.keydown(function(e){
    var keyCode = e.keyCode || e.which;

    if (keyCode == 9) {
        return null
    }

    try {
        $input.unmask();
    } catch (e) {}

    var tamanho = $input.val().length;

    if(tamanho < 11){
        $input.mask("999.999.999-99");
    } else {
        $input.mask("99.999.999/9999-99");
    }

    // ajustando foco
    var elem = this;
    setTimeout(function(){
        // mudo a posição do seletor
        elem.selectionStart = elem.selectionEnd = 10000;
    }, 0);
    // reaplico o valor para mudar o foco
    var currentValue = $(this).val();
    $(this).val('');
    $(this).val(currentValue);
});

$input.on('focusin click', function(e){
    $input.parent().next().find('li').text("");
});

$input.on('focusout', function(e){
    var value = $input.val();

    if (value.length >= 11) {
        $.get(
            $input.data('validate-url'),
            { "document": value },
            function(data, status){
                if (data['error']) {
                    $input.parent().next().find('li').text("Documento inválido");
                }
            }
        )
    }
})